export enum ComplianceScoreImpactEnum {
  BLOCKING_NO_FEEDBACK = 'BLOCKING_NO_FEEDBACK',
  BLOCKING_WITH_FEEDBACK = 'BLOCKING_WITH_FEEDBACK',
  // Not offered in the UI yet
  ADVISORY = 'ADVISORY',
}
